import { memo } from "react";
import Box from "@mui/material/Box";
import type { OnboardingPaymentMethodProps } from "./types";

const OnboardingSelectedPaymentMethod = ({
    imageUrl,
    displayName
}: OnboardingPaymentMethodProps) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 5
        }}
    >
        <Box
            component='img'
            src={imageUrl}
            alt='displayName'
            sx={{
                objectFit: 'contain',
                width: '100%',
                height: '100%',
                maxHeight: 64,
                maxWidth: 80
            }}
        />
        <Box
            sx={{
                fontWeight: 'bold',
                fontSize: 16,
                mt: 1,
                textAlign: 'center',
                color: 'text.primary',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontFamily: 'Public Sans, sans-serif'
            }}
        >
            {displayName}
        </Box>
    </Box>
);

export default memo(OnboardingSelectedPaymentMethod);
